import { render, staticRenderFns } from "./QuestionQuizFullPage.vue?vue&type=template&id=bd0ef784&scoped=true"
import script from "./QuestionQuizFullPage.js?vue&type=script&lang=js&external"
export * from "./QuestionQuizFullPage.js?vue&type=script&lang=js&external"
import style0 from "./QuestionQuizFullPage.vue?vue&type=style&index=0&id=bd0ef784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0ef784",
  null
  
)

export default component.exports